import axios from "axios";
import * as Constants from "../constant";

const createExperience = async (formData) => {
	try {
		const response = await axios.post(
			`${Constants?.LOCAL_URL}/space`,
			formData
		);
		return response;
	} catch (error) {
		return error;
	}
};
export default createExperience;
export const updateExperience = async (formData, id) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/space/experiance/${id}`,
			formData
		);
		return response;
	} catch (error) {
		return error;
	}
};
